var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "29",
      "height": "31",
      "viewBox": "0 0 29 31",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M28.468 5.646a.456.456 0 00-.355-.744H10.702A5.361 5.361 0 108.368 9.8l6.747 8.34V27.8a.586.586 0 01-.355.538l-4.142 1.788a.456.456 0 00.18.875h11.88a.457.457 0 00.18-.875l-4.143-1.788a.586.586 0 01-.354-.538V18.14L28.468 5.646zM4.858 9.78a4.45 4.45 0 114.93-4.877H5.364a.456.456 0 00-.355.743l2.784 3.44a4.441 4.441 0 01-2.934.694zm13.495 19.396l2.113.912h-7.459l2.113-.912a1.499 1.499 0 00.906-1.377v-9.82a.456.456 0 00-.102-.286L6.319 5.815h20.838L17.55 17.693a.456.456 0 00-.102.287v9.819a1.499 1.499 0 00.905 1.377z",
      "fill": "#F1D5AA"
    }
  }), _c('path', {
    attrs: {
      "d": "M23.154 8.792a.457.457 0 00-.515-.178c-2.32.733-3.49.35-4.846-.096a10.339 10.339 0 00-3.494-.652c-2.59 0-3.802.768-3.852.8a.456.456 0 00-.106.67l6.04 7.468a.457.457 0 00.71 0l6.04-7.468a.457.457 0 00.023-.544zm-6.418 7l-5.317-6.574a8.36 8.36 0 012.879-.44 9.435 9.435 0 013.21.608c1.17.383 2.289.75 4.056.436l-4.828 5.97zM5.36 3.979a.456.456 0 00.457-.456V2.29a.456.456 0 00-.913 0v1.233a.456.456 0 00.457.456zM4.904 8.431a.456.456 0 00.913 0V7.199a.456.456 0 00-.913 0V8.43zM3.981 5.359a.456.456 0 00-.456-.457H2.292a.456.456 0 000 .913h1.233a.457.457 0 00.456-.456zM6.661 4.518a.455.455 0 00.322-.134l.872-.871a.457.457 0 00-.646-.646l-.87.871a.457.457 0 00.322.78zM3.742 6.335l-.871.87a.456.456 0 10.645.646l.871-.871a.456.456 0 00-.645-.645zM3.514 2.867a.456.456 0 10-.645.646l.872.87a.456.456 0 10.645-.645l-.872-.87z",
      "fill": "#F1D5AA"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }